__turbopack_context__.v({
  "breadcrumbs": "bjHI0a_breadcrumbs",
  "feedback": "bjHI0a_feedback",
  "header": "bjHI0a_header",
  "headerActions": "bjHI0a_headerActions",
  "notification": "bjHI0a_notification",
  "root": "bjHI0a_root",
  "search": "bjHI0a_search",
});
